import React, { useEffect, useState } from "react";
import styles from "./YardsaleDetails.module.css";
import { Modal, SubmitButton, TextComponent } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { IoIosArrowBack } from "react-icons/io";
import { Carousel, Input } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { YardsaleMiddleware } from "../../../Store/Middlewares/YardsalesMiddleware";
import moment from "moment";
import { IMAGE_BASE_URL } from "../../../config/APIs";
import AVATAR from "../../../assets/images/alternate.png";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const YardsaleDetails = () => {

  const navigate = useNavigate();
  const userID = useLocation()?.state?.userId;

  const dispatch = useDispatch();
  const DETAILS = useSelector(state => state.YardsaleReducer?.yardSaleDetails);

  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const [reason, setReason] = useState("");

  useEffect(() => {
    getDetailsData()
  }, []);


  const getDetailsData = () => {
    const data = {
      id: userID,
    };
    dispatch(YardsaleMiddleware.onGetYardsaleDetails(data))
      .then((res) => { })
      .catch((err) => { console.log("Error fetching yardsale details:", err) });
  }

  const onClickDeactivateSale = () => {
    if (!reason) {
      dispatch(showAlert({ message: "Please enter a reason for deactivation", type: "Warning" }))
      return;
    }
    setOpenDeactivateModal(false);
    dispatch(YardsaleMiddleware.onDeactivateYardsale({ id: DETAILS?.id, reason: reason }))
      .then((res) => { navigate(-1) })
      .catch((err) => { console.log("Error clicking deactivate", err) })

  }

  return (
    <div className={styles.mainCont}>

      <div className={styles.HeadingDiv}>
        <IoIosArrowBack
          className={styles.backIcon}
          onClick={() => navigate(-1)}
        />


        <HeadingComponent
          text={"Yardsale Details"}
          fontSize={"var(--heading-font-size)"}
        />
      </div>
      <div className={styles.subCont}>
        <div className={styles.leftCont}>

          <HeadingComponent text={DETAILS?.title} className={styles.SaleTitle} />

          <div className={styles.Box}>
            <div className={styles.row}>
              <img src={DETAILS?.userId?.profileImage ? IMAGE_BASE_URL + DETAILS?.userId?.profileImage : AVATAR} className={styles.UserImg} />
              <div>
                <TextComponent text={"Created By,"} className={styles.LabelStyle} />
                <TextComponent text={(DETAILS?.userId?.firstName ?? ' ') + " " + (DETAILS?.userId?.lastName ?? ' ')} className={styles.title} />
              </div>
            </div>


            <div className={styles.ItemDiv}>
              <TextComponent text={"Category"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.category} className={styles.descStyle} />
            </div>

            <div className={styles.ItemDiv}>
              <TextComponent text={"Interested Buyers: "} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.interestedCount} className={styles.descStyle} />
            </div>


            <div className={styles.ItemDiv}>
              <TextComponent text={"Starting Date"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.startDate ? moment(DETAILS?.startDate).format("MMM DD, YYYY") : ''} className={styles.descStyle} />
            </div>


            <div className={styles.ItemDiv}>
              <TextComponent text={"Ending Date"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.endDate ? moment(DETAILS?.endDate).format("MMM DD, YYYY") : ('')} className={styles.descStyle} />
            </div>

            <div className={styles.ItemDiv}>
              <TextComponent text={"Start Time"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.startTime ? moment(DETAILS?.startTime, 'hh:mm').format("LT") : ('')} className={styles.descStyle} />
            </div>

            <div className={styles.ItemDiv}>
              <TextComponent text={"End Time"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.endTime ? moment(DETAILS?.endTime, 'hh:mm').format("LT") : ('')} className={styles.descStyle} />
            </div>

            <div className={styles.ItemDiv}>
              <TextComponent text={"Location"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.location?.address} className={styles.descStyle} />
            </div>

            <div className={styles.ItemDiv}>
              <TextComponent text={"Status"} className={styles.LabelStyle} />

              <TextComponent text={DETAILS?.status + (DETAILS?.reason ? ' by admin' : '')} className={styles.descStyle} style={{ color: DETAILS?.status == 'cancelled' ? 'red' : 'green', textTransform: 'capitalize' }} />
            </div>


            {
              (DETAILS?.status == 'cancelled' && DETAILS?.reason) &&

              <div className={styles.ItemDiv}>
                <TextComponent text={"Reason of cancellation"} className={styles.LabelStyle} />
                <TextComponent text={DETAILS?.reason} className={styles.descStyle} />
              </div>
            }




            <TextComponent text={"Description"} className={styles.LabelStyle} />
            <TextComponent text={DETAILS?.description} className={styles.descStyle} />

            {
              DETAILS?.status == 'ongoing' || DETAILS?.status == 'upcoming' &&
              <SubmitButton title={"Deactivate Yardsale"} primary btnClass={styles.btn} onClick={() => setOpenDeactivateModal(true)} />

            }

          </div>

        </div>


        <div className={styles.rightCont}>

          <Carousel>

            {
              DETAILS?.images?.map((item, index) => {
                return (
                  <div key={index}>
                    <img src={item ? IMAGE_BASE_URL + item : AVATAR} className={styles.image} />
                  </div>
                );
              })
            }


          </Carousel>


        </div>
      </div>


      <Modal
        footer={false}
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={openDeactivateModal}
        onCancel={() => {
          setOpenDeactivateModal(false)
        }}
      >
        <div className={styles.modal}>
          <TextComponent text={"Deactivate Yardsale"} className={'modalheading'} />


          <Input.TextArea
            className={'modalInput'}
            placeholder="Reason for deactivation"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
          />


          <div className={'modalFooter'}>

            <SubmitButton
              title={"Cancel"}
              btnClass={'modalBtn'}
              primary
              onClick={() => setOpenDeactivateModal(false)}
            />


            <SubmitButton
              title={"Submit"}
              btnClass={'modalBtn'}
              secondaryBtn
              onClick={onClickDeactivateSale}
            />
          </div>

        </div>
      </Modal>


    </div>
  );
};

export default YardsaleDetails;
